import type { ReactNode } from 'react';

import './FormField.styl';

type Props = { label: string; htmlFor?: string; error?: string; hint?: string; children: ReactNode };

export function FormField({ label, htmlFor, error, hint, children }: Props) {
  return (
    <div className={error ? 'm-field m-field--error' : 'm-field'}>
      <label className="m-field__label" htmlFor={htmlFor}>
        {label}
      </label>
      {children}
      {error ? (
        <div className="m-field__error" role="alert">
          {error}
        </div>
      ) : hint ? (
        <div className="m-field__hint">{hint}</div>
      ) : null}
    </div>
  );
}
